import "swiper/swiper.min.css";
import "./App.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import React from "react";
import { Routes, Route } from "react-router-dom";
import AppRoutes from "./routes/Routes";
import ChangeContentProvider from './context/contentContext';

function App() {
  useEffect(() => {
  AOS.init({
    once: true, // animation happens only once
    duration: 1000, // adjust global duration if needed
  });
  AOS.refresh(); // ensure AOS recalculates positions
}, []);
  return (
    <ChangeContentProvider>
      <Routes>
        <Route path="/*" element={<AppRoutes />} />
      </Routes>
    </ChangeContentProvider>
  );
}

export default App;
